module.exports = __webpack_public_path__ + "img/14-1.314fce54.jpg";